export default __webpack_public_path__ + "static/media/slot-icon.dcdb428a.svg";